module.exports = __webpack_public_path__ + "img/Pizza.a67aaf0f.png";